import { QueryClient } from '@tanstack/react-query';

const queryConfig = {
  queries: {
    //useErrorBoundary: true,
    refetchOnWindowFocus: false,
    //staleTime: 60 * 1000 * 5,
    retry: false,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
